import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from '../../Store';
import ComponentList from './ComponentList';
import ComponentLink from './ComponentLink';
import reducerRegistry from '../../ReducerRegistry';
import reducer from './Reducer';
reducerRegistry.register('notifications', reducer);
const notificationLinkElement = document.getElementById('user_notifications');
if (notificationLinkElement) {
    render(_jsx(Provider, Object.assign({ store: store }, { children: _jsx(ComponentList, { link: notificationLinkElement.getAttribute('data-href') }) })), notificationLinkElement);
}
const notificationItems = document.getElementsByName('notification_item');
if (notificationItems) {
    Array.prototype.forEach.call(notificationItems, (item) => {
        const id = Number(item.getAttribute('data-id'));
        render(_jsx(Provider, Object.assign({ store: store }, { children: _jsx(ComponentLink, { id: id, title: item.getAttribute('data-title') }) })), item);
    });
}
